// Lib
import React, { ReactElement } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
// @ts-ignore No react-router v3.2.1 types
import { Link } from '../../../../../node_module_clones/react-router';

// Utils
import { buildAppRegisterOverlayUrl } from '../../../../auth/modals/register/registrationUtils';

// Selectors
import { getLocationQuery } from '../../../../app/routingSelector';

// Constants
import { REGISTRATION_ENTRY_POINT } from '../../../../../common/users/userConstants';
import {
    DEFAULT_USER_INITIAL_EDUCATION,
    DEFAULT_USER_ONBOARDING,
} from '../../../../../common/users/userEducationConstants';

// Styles
import './SignUpToMilanoteButton.scss';

const mapStateToProps = createStructuredSelector({
    locationQuery: getLocationQuery,
});

interface SignUpToMilanoteButtonProps {
    locationQuery: object;
}

const SignUpToMilanoteButton = (props: SignUpToMilanoteButtonProps): ReactElement => {
    const { locationQuery } = props;

    const appRegisterUrl = buildAppRegisterOverlayUrl({
        currentBoardId: undefined,
        locationQuery,
        permissionId: undefined,
        initialEducation: DEFAULT_USER_INITIAL_EDUCATION,
        onboarding: DEFAULT_USER_ONBOARDING,
        registrationEntryPoint: REGISTRATION_ENTRY_POINT.UTM_REGISTRATION,
    });

    return (
        <Link className="SignUpToMilanoteButton" to={appRegisterUrl}>
            Sign up for free
        </Link>
    );
};

export default connect(mapStateToProps)(SignUpToMilanoteButton);
